<template>
  <section class="page-section cta">
    <div class="container">
      <div class="row">
        <div class="col-xl-9 mx-auto">
          <div class="cta-inner text-center rounded">
            <h2 class="section-heading mb-5">
              <span class="section-heading-upper">How to</span>
              <span class="section-heading-lower">Contact me</span>
            </h2>
            <ul class="list-unstyled list-hours mb-5 text-left mx-auto">
              <li class="list-unstyled-item list-hours-item d-flex">
                Email
                <span class="ml-auto">fabio.costa94@outlook.it</span>
              </li>
              <li class="list-unstyled-item list-hours-item d-flex">
                Phone
                <span class="ml-auto">+39 3473825418</span>
              </li>
              <li class="list-unstyled-item list-hours-item d-flex">
                Linkedin
                <a
                  class="ml-auto"
                  href="https://www.linkedin.com/in/fabio-costa-66738818b"
                  >linkedin.com/fabio-costa</a
                >
              </li>
              <li class="list-unstyled-item list-hours-item d-flex">
                Telegram
                <span class="ml-auto">@Memo</span>
              </li>
              <li class="list-unstyled-item list-hours-item d-flex">
                Discord
                <span class="ml-auto">Mustungun #1743</span>
              </li>
              <li class="list-unstyled-item list-hours-item d-flex">
                Facebook
                <a class="ml-auto" href="https://www.facebook.com/Cinghialeh"
                  >Fabio Costa</a
                >
              </li>
              <li class="list-unstyled-item list-hours-item d-flex">
                Address
                <span class="ml-auto">Cagliari, Sardinia IT</span>
              </li>
            </ul>
            <p class="address mb-5">
              <em>
                <strong>I don't check Facebook unless warned previously</strong>
                <!-- <br>
                  Golden Valley, Minnesota -->
              </em>
            </p>
            <!-- <p class="mb-0">
                            <small>
                  <em>Call Anytime</em>
                </small>
                            <br> (317) 585-8468
                        </p> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data: function () {
    return {
      number: 5,
    };
  },
};
</script>

<style lang="scss">
.list-hours {
  font-size: 0.9rem;
  .list-hours-item {
    border-bottom: 1px solid fade-out($primary, 0.5);
    padding-bottom: 0.25rem;
    margin-bottom: 1rem;
    font-style: italic;
    &.today {
      font-weight: bold;
      color: $primary;
    }
  }
  @media (min-width: 992px) {
    width: 50%;
    font-size: 1.1rem;
  }
}

.address {
  strong {
    font-size: 1.2rem;
  }
}
</style>
